import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { useParams } from 'react-router-dom';
import "./index.css";
import { Toaster } from "sonner";
import DomainGateway from "./pages/DomainGateway";
import TenantLogin from "./pages/TenantLogin";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import AdminMasterView from "./pages/AdminMasterView";
import TenantDashboard from "./pages/TenantDashboard";
import IncomeDesk from "./pages/IncomeDesk";
import ExpenseDesk from "./pages/ExpenseDesk";
import PartyMaster from "./pages/PartyMaster";
import AuditLogs from "./pages/AuditLogs";
import PaymentDesk from "./pages/PaymentDesk";
import ReportsDesk from "./pages/ReportsDesk";

import CompanySettings from "./pages/CompanySettings";
const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  
  if (loading) return <div className="h-screen w-full flex items-center justify-center bg-slate-50"><div className="w-8 h-8 border-4 border-[#0A192F] border-t-transparent rounded-full animate-spin"></div></div>;
  if (!user) {
    if (requiredRole === 'admin') return <Navigate to="/adminpanel/login" replace />;
    return <Navigate to="/" replace />; // Or domain gateway
  }
  
  if (requiredRole && user.role !== requiredRole) {
      return <Navigate to="/" replace />;
  }

  return children;
};

const TenantProtectedRoute = ({ children }) => {
     const { user, loading } = useAuth();
     const { clientSlug } = useParams();
     
     if (loading) return <div className="h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-[#0A192F] border-t-transparent rounded-full"></div></div>;
     
     if (!user) return <Navigate to="/" replace />;
     
     if (user.role === 'admin') return children; 
     
     if (user.client_slug && user.client_slug !== clientSlug) {
         return <Navigate to={`/${user.client_slug}`} replace />;
     }

     return children;
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Static Admin Routes must be defined at the very top to prevent dynamic route swallowing */}
              <Route path="/adminpanel" element={<Navigate to="/adminpanel/login" replace />} />
              <Route path="/adminpanel/login" element={<AdminLogin />} />
              <Route path="/adminpanel/dashboard" element={
                <ProtectedRoute requiredRole="admin">
                    <AdminPanel />
                </ProtectedRoute>
              } />
              <Route path="/adminpanel/master-view" element={
                <ProtectedRoute requiredRole="admin">
                    <AdminMasterView />
                </ProtectedRoute>
              } />

              <Route path="/" element={<DomainGateway />} />

              {/* Dynamic Tenant Routes */}
              <Route path="/:clientSlug/login" element={<TenantLogin />} />
              <Route path="/:clientSlug" element={<TenantProtectedRoute><TenantDashboard /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/income" element={<TenantProtectedRoute><IncomeDesk /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/expense" element={<TenantProtectedRoute><ExpenseDesk /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/parties" element={<TenantProtectedRoute><PartyMaster /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/payments" element={<TenantProtectedRoute><PaymentDesk /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/reports" element={<TenantProtectedRoute><ReportsDesk /></TenantProtectedRoute>} />
              <Route path="/:clientSlug/audit" element={<TenantProtectedRoute><AuditLogs /></TenantProtectedRoute>} />

              <Route path="/:clientSlug/settings" element={<TenantProtectedRoute><CompanySettings /></TenantProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors closeButton position="top-right" />
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
